"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CheckRound = _interopRequireDefault(require("@rsuite/icon-font/lib/status/CheckRound"));

// Generated by script, don't edit it please.
var CheckRound = (0, _createSvgIcon["default"])({
  as: _CheckRound["default"],
  ariaLabel: 'check round',
  category: 'status',
  displayName: 'CheckRound'
});
var _default = CheckRound;
exports["default"] = _default;
module.exports = exports.default;